import { render, staticRenderFns } from "./ParentPage.vue?vue&type=template&id=62fc4080"
import script from "./ParentPage.vue?vue&type=script&lang=ts"
export * from "./ParentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports